<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.title" placeholder="标题"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getInfos">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="infos" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection"  min-width="40">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="info_type_name" label="信息类型"  width="100">
			</el-table-column>
			<!--
			<el-table-column prop="group_name" label="产品组"  width="80">
			</el-table-column>
			<el-table-column prop="app_name" label="产品"  width="80">
			</el-table-column>
			-->
			<el-table-column prop="title" label="标题" width="200" >
			</el-table-column>
			<el-table-column prop="content" label="概要描述" width="300" >
			</el-table-column>
			<el-table-column prop="open_type_name" label="打开类型" width="150" >
			</el-table-column>
			<el-table-column prop="maker_name" label="创建人" width="80" >
			</el-table-column>
			<el-table-column prop="make_date" label="创建时间" width="180" >
			</el-table-column>
			<el-table-column label="操作" min-width="140">
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" @close="cancelSubmit"  size="small" >
			<el-form :model="editForm"    label-width="100px" :rules="editFormRules" ref="editForm">
        			
				   <el-form-item label="信息类型" prop="info_type">
					 <el-select v-model="editForm.info_type"  placeholder="请选择" style="width:400px;">
                        <el-option  v-for="(item,index) in infoTypes" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				   </el-form-item>

				   	<el-form-item label="产品组" prop="app_group_tmp">
					 <el-select v-model="editForm.app_group_tmp" clearable multiple  placeholder="请选择" @change="appGroupChange"  @visible-change="visibleChange" @remove-tag="removeTag" style="width:400px;">
                        <el-option  v-for="(item,index) in appgroups" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				   </el-form-item>


				   	<el-form-item label="产品" prop="app_id_tmp">
					 <el-select v-model="editForm.app_id_tmp" clearable multiple  placeholder="请选择" style="width:400px;">
                        <el-option  v-for="(item,index) in apps" :key="index" :label="item.app_name"  :value="item.id"> </el-option>
                     </el-select>
				   </el-form-item>

				  <el-form-item label="显示类型" prop="show_type"  >
					 <el-select v-model="editForm.show_type"  placeholder="请选择" style="width:400px;" @change="showTypeChange">
                        <el-option  v-for="(item,index) in showTypes" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				   </el-form-item>
			
				
				<el-form-item label="标题" prop="title">
					<el-input v-model="editForm.title" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="概要描述" prop="content">
				     <el-input type="textarea"  :rows="2" v-model="editForm.content" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="音/视频名称" prop="play_name"  v-if="editForm.show_type=='5' || editForm.show_type=='6'">
					<el-input v-model="editForm.play_name" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="作者" prop="author"  v-if="editForm.show_type=='5' || editForm.show_type=='6'">
					<el-input v-model="editForm.author" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="音/视频时长" prop="duration"  v-if="editForm.show_type=='5' || editForm.show_type=='6'">
					<el-input v-model="editForm.duration" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="上传音频" v-if="editForm.show_type=='6'">
				<el-upload :action="audioupload" :on-success="handleAudioSuccess" :file-list="editForm.audio" :on-remove="handleAudioRemove">
				<el-button size="small" type="primary">点击上传</el-button>				
				</el-upload>
				</el-form-item>

				<el-form-item label="上传歌词" v-if="editForm.show_type=='6'">
				<el-upload :action="lyricupload" :on-success="handleLyricSuccess" :file-list="editForm.lyric_tmp" :on-remove="handleLyricRemove">
				<el-button size="small" type="primary">点击上传</el-button>				
				</el-upload>
				</el-form-item>

                <el-form-item label="上传视频" v-if="editForm.show_type=='5'">
				<el-upload :action="videoupload" :on-success="handleVideoSuccess" :file-list="editForm.video" :on-remove="handleVideoRemove">
				<el-button size="small" type="primary">点击上传</el-button>				
				</el-upload>
				</el-form-item>
				

				<el-form-item label="对应文章" prop="article_id" >
					 <el-select v-model="editForm.article_id" clearable filterable   placeholder="请选择" @change="articleChange" style="width:400px;">
                        <el-option  v-for="(item,index) in articles" :key="index" :label="item.title"  :value="item.id"> </el-option>
                     </el-select>
				   </el-form-item>

                <el-form-item label="上传图片" >
				<el-upload :action="imageupload"
						list-type="picture-card" ref="upload"  :file-list="editForm.img_url_tmp" :on-remove="handleRemove" :on-success="handlePictureSuccess">
				<i class="el-icon-plus"></i>
				</el-upload>
				<el-dialog v-model="dialogVisible" size="tiny">
						<img width="100%" :src="dialogImageUrl" alt="">
				</el-dialog>
				</el-form-item>


				<el-form-item label="打开类型" prop="open_type" >
				     	<el-select v-model="editForm.open_type"  placeholder="请选择"  @change="openTypeChange" style="width:400px;">
                        <el-option  v-for="(item,index) in openTypes" :key="index"  :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item label="App" prop="app" v-if="editForm.open_type=='03'"  >
				     <el-input v-model="editForm.app" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="网址" prop="url" v-if="editForm.open_type=='01' || editForm.open_type=='03'"   :rules="[{ required: this.editForm.open_type=='01', message: '请输入网址', trigger: 'blur' },{ type: 'url', message: '请输入正确的网址', trigger: 'blur' }]">
				     <el-input v-model="editForm.url" auto-complete="off" ></el-input>
				</el-form-item>

				<el-form-item label="跳转页" prop="jump" v-if="editForm.open_type=='02'" :rules="[{ required: this.editForm.open_type=='02', message: '请选择跳转页', trigger: 'change' }]">
				     	<el-select v-model="editForm.jump"  placeholder="请选择" @change="jumpChange"  style="width:400px;">
                        <el-option  v-for="(item,index) in jumps" :key="index"  :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>

				
				<el-form-item v-if="editForm.open_type=='02'" v-for="(oitem, index) in editForm.jump_params_tmp"  :key="index">
					<el-col :span="6">
							<el-form-item :label="'参数名' + (index+1)" label-width='70px' >				
								<el-input v-model="oitem.param_name" disabled auto-complete="off" style="width:120px;" ></el-input>					
							</el-form-item>
					</el-col>
					<el-col :span="7">
							<el-form-item :prop="'jump_params_tmp.' + index + '.param_value'" :label="'参数值'+ (index+1)" label-width='80px' :rules="{ required:editForm.open_type=='02',message: '请录入参数值', trigger:'blur'}">				
									<el-input v-model="oitem.param_value" auto-complete="off"  style="width:120px;"></el-input>					
							</el-form-item>
					</el-col>					   
				</el-form-item>              
                  
              <el-form-item label="">					
					 <el-checkbox v-model="editForm.top">置顶</el-checkbox>					
			  </el-form-item>	
		
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getInfoListPage,addInfo,editInfo, removeInfo,batchRemoveInfo,getJump,getJumpParams,getAppGroup,getApp,getInfoBase,upload,imgDel,imgsDel,articleUrl,runType } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
 
	export default {
		data() {
			return {
				filters: {
					title: ''
				},
				dialogImageUrl: '1',
                dialogVisible: false,
				imageupload:upload+'?runType='+runType+'&type=1&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				audioupload:upload+'?runType='+runType+'&type=2&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				videoupload:upload+'?runType='+runType+'&type=3&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				lyricupload:upload+'?runType='+runType+'&type=4&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				selectchangeflag:0,
				appgroups:[],
				apps:[],
				infoTypes:[],
				openTypes:[],
				showTypes:[],
				articles:[],
				jumps:[],				
				infos: [],
				total: 0,
				pageSize:20,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					content: [
						{ required: true, message: '概要描述', trigger: 'blur' }
					],
					title:[ {  required: true, message: '请输入标题', trigger: 'blur' }]
					
				},
				 edit_img_url:[], //修改时添加的图片数组
				 del_tmp:[],  //修改时删除原有图片的数组，提交时进行处理
				
				//编辑界面数据
				editForm: {
					id: 0,						
					info_type:'01',
					title:'',
					content:'',
					open_type:'01',
					url:'',					
					jump:'',
					jump_params_tmp:[],
					app_group_tmp:[],
					app_id_tmp:[],
					show_type:'1',
                     top:false,
					 img_url_tmp:[],
					 article_id:'',
					 app:'',
					 play_name:'',
					 author:'',
					 duration:'',
					 video:[],
					 audio:[],
					 lyric_tmp:[]

             
				},
				
				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			cancelSubmit:function(){
               
				if(this.formStatus==0)
				{			
					if (this.editForm.img_url_tmp.length>0){
						this.imgDel(JSON.stringify(this.editForm.img_url_tmp),true);						
						
					}
			 	}
				if(this.formStatus==1)
				{					
					if (this.edit_img_url.length>0){						
						this.imgDel(JSON.stringify(this.edit_img_url),true);
					}
				}
               this.editForm.img_url_tmp=[];
               this.edit_img_url.length=[];
			   this.del_tmp=[];	 
			   if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
			},
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getInfos();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfos();
			},
	  imgDel(filename,Multiple){
                    
					var imgUrl=imgDel;
		            if (Multiple)
					{
                         imgUrl=imgsDel;
					}
      				this.$http.jsonp(imgUrl,{params: {CurrentUserID:CurrentUserID,Session:Session,fileName:filename,type:1,runType:runType}}).then(
						function(res){                         
							if (res.data.result_code!=200)
							{                           
								this.$message({
								message:'删除文件错误',
								type: 'error'
								});
							}
						},
						function(res)
						{
							this.$message({
									message:'删除文件错误',
									type: 'error'
									});
							
						});

	  },
	  handleRemove(file, fileList) {
		     
             for(var i=0; i<this.editForm.img_url_tmp.length; i++) {
				if(this.editForm.img_url_tmp[i].name == file.name) {				  
				   	if(this.formStatus==0)
	             	{		
					   this.editForm.img_url_tmp.splice(i, 1);			  
                       this.imgDel(file.name,false);
		            }
					if (this.formStatus==1)
					{					
                          this.del_tmp.push({name:file.name});
                           
					}
				   
				break;
				}
			 }
			

		if(this.formStatus==1)
		{
              
		     for(var i=0; i<this.edit_img_url.length; i++) {				
				if(this.edit_img_url[i].name == file.name) {								
				   this.edit_img_url.splice(i, 1);
	                this.imgDel(file.name,false);
				   
				break;
				}
			 }
			}
		   
        
      },

	  handlePictureSuccess(response, file, fileList) {
      file.name=response.file_name;
	  file.url=response.file_url;
	  var obj={name:response.file_name,url:response.file_url};
		if (this.formStatus==0)
		{
		  this.editForm.img_url_tmp.push(obj);	  
		}
		if (this.formStatus==1)  
		{
			this.edit_img_url.push(obj);
		}
      },

	  handleVideoSuccess(response, file, fileList) {		
      file.name=response.file_name;
	  file.url=response.file_url;	
	  var obj={name:response.file_name,url:response.file_url};	 
	   
	  if (this.editForm.video.length>0)	
	  {		 
		  var f=this.editForm.video.pop();		
          this.fileDel(f.name,3);
	  }
	  	 
	  this.editForm.video.push(obj);
	 this.editForm.url=response.file_url;	
	  	 
		 
		
      },
	  handleVideoRemove(file, fileList) {		     
           	
		  this.editForm.video.splice(0, 1);			  
          this.fileDel(file.name,3);	
		  this.editForm.url='';	
        
      },

	 handleAudioSuccess(response, file, fileList) {
		 
      file.name=response.file_name;
	  file.url=response.file_url;
	  var obj={name:response.file_name,url:response.file_url};	
	  if (this.editForm.audio.length>0)	
	  {
		 
		  var f=this.editForm.audio.pop();
		
         this.fileDel(f.name,2);
	  }	 
	   
		  this.editForm.audio.push(obj);	
		  this.editForm.url=response.file_url;	  
		
      },
	  handleAudioRemove(file, fileList) {		     
           	
		  this.editForm.audio.splice(0, 1);			  
          this.fileDel(file.name,2);	
		  this.editForm.url='';	
        
      },

	  
	 handleLyricSuccess(response, file, fileList) {
      file.name=response.file_name;
	  file.url=response.file_url;
	  var obj={name:response.file_name,url:response.file_url};	
	 
	  if (this.editForm.lyric_tmp.length>0)	
	  {
		 
		  var f=this.editForm.lyric_tmp.pop();
		
         this.fileDel(f.name,4);
	  }	 
		  this.editForm.lyric_tmp.push(obj);			 
		
      },
	  handleLyricRemove(file, fileList) {		     
           	
		  this.editForm.lyric_tmp.splice(0, 1);			  
          this.fileDel(file.name,4);	
		 
        
      },

	fileDel(filename,type){
                    
				
					var imgUrl=imgDel;
		           	this.$http.jsonp(imgUrl,{params: {CurrentUserID:CurrentUserID,Session:Session,fileName:filename,type:type,runType:runType}}).then(
						function(res){                         
							if (res.data.result_code!=200)
							{                           
								this.$message({
								message:'删除文件错误',
								type: 'error'
								});
							}
						},
						function(res)
						{
							this.$message({
									message:'删除文件错误',
									type: 'error'
									});
							
						});

	  },
		showTypeChange(val)
		{
			
			if (this.formStatus==0 && val!=5 && val!=6)
			{
				this.editForm.duration='';
				this.editForm.play_name='';
				this.editForm.author='';
			}
			
		},

		openTypeChange(val)
		{
			//this.$refs['editForm'].resetFields();
			if (this.formStatus==0)
			{
				this.editForm.url='';
				this.editForm.jump='';
				this.editForm.jump_params_tmp=[];
			}
			
		},
			visibleChange(val)
			  {
                 if(val)
				 {
                      this.selectchangeflag=1;
				 }else{
                       this.selectchangeflag=0;
				 }
			  },
			  removeTag(val)
			  {
                  this.selectchangeflag=1;
			  },
				jumpChange(val)
				{
				   				
				   this.$http.jsonp(getJumpParams,{params: {CurrentUserID:CurrentUserID,Session:Session,Jump:val }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
             			this.editForm.jump_params_tmp=res.data.jumpparams;
					}
					else{                           
						this.$message({
						message:'获取参数错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取参数错误',
								type: 'error'
								});
						
					});
				   
				},
				articleChange(val)
				{
					if (val==null || val=='')
					{
						if(this.editForm.show_type!='5' && this.editFrom.show_type!='6')
						{
						   this.editForm.url='';
						}
					}
					else
					{
							this.editForm.url=articleUrl+'?article_id='+val;
					}					
				   
				},
				appGroupChange(val)
				{
                   
					if (this.selectchangeflag==0) return;
					this.apps=[];
					this.editForm.app_id_tmp=[];
					if (val==''  ) return;
				   				
				    this.getApp(val.join(','));
				   
				},

				getApp(val){
					this.$http.jsonp(getApp,{params: {CurrentUserID:CurrentUserID,Session:Session,appGroup:val }}).then(
										function(res){                         
										if (res.data.result_code==200)
										{						
											this.apps=res.data.apps;
											if (this.apps.length==0)
											{
												this.editForm.app_id_tmp=[];
											}
										}
										else{                           
											this.$message({
											message:'获取产品错误',
											type: 'error'
											});
										}
									

										},
										function(res)
										{
											this.$message({
													message:'获取产品错误',
													type: 'error'
													});
											
										});

				},
			 getJump(){
             	 this.$http.jsonp(getJump,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.jumps=res.data.jumps;					
					}
					else{                           
						this.$message({
						message:'获取跳转页失败',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取跳转页失败',
								type: 'error'
								});
						
					});


			},
		   getAppGroup(){
             	 this.$http.jsonp(getAppGroup,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.appgroups=res.data.appgroups;					
					}
					else{                           
						this.$message({
						message:'获取产品组错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取产品组错误',
								type: 'error'
								});
						
					});


			},
			getBase(){
             	 this.$http.jsonp(getInfoBase,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						
						this.infoTypes=res.data.infoTypes;	
						this.openTypes=res.data.openTypes;
						this.showTypes=res.data.showTypes;	
						this.articles=res.data.articles;	

						
					}
					else{                           
						this.$message({
						message:'获取基础信息错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取基础信息错误',
								type: 'error'
								});
						
					});


			},
			getInfos() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					title: this.filters.title,					
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getInfoListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.infolist.total;
					         this.infos = res.data.infolist.infos;
					         this.listLoading = false;
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )

			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };


                   this.$http.jsonp(removeInfo, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;

				
				this.selectchangeflag=0;
				
				this.editForm = Object.assign({}, row); 

				

				this.editForm.top=this.editForm.top>0?true:false; 	
                this.editForm.app_group_tmp=JSON.parse(row["app_group_tmp"]);
				this.editForm.app_id_tmp=JSON.parse(row["app_id_tmp"]);	

				this.editForm.video=JSON.parse(row["video"]);	
				this.editForm.audio=JSON.parse(row["audio"]);	
				this.editForm.lyric_tmp=JSON.parse(row["lyric_tmp"]);	

				this.getApp(this.editForm.app_group_tmp.join(','));
				this.$set(this.editForm,"jump_params_tmp",JSON.parse(row["jump_params_tmp"]));
               this.$set(this.editForm,"img_url_tmp",JSON.parse(row["img_url_tmp"]));

				this.editFormVisible = true;
      			
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				
				this.editFormVisible = true;
				this.del_tmp=[];
			    this.edit_img_url=[];
				this.editForm = {
					id: 0,									
					info_type:'01',
					title:'',
					content:'',
					open_type:'01',
					url:'',
					jump:'',
					jump_params_tmp:[],
				    app_group_tmp:[],
					app_id_tmp:[],
					show_type:'1',
                    top:false,
					img_url_tmp:[],
					 article_id:'',
					 app:'',
					 play_name:'',
					 author:'',
					 duration:'',
					 video:[],
					  audio:[],
					 lyric_tmp:[]
				};
				
                if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
			},
			//编辑
			editSubmit: function () {

				if (this.editForm.app_group_tmp.length==0)
				{
				    this.$message({
                                message:'请选择产品组',
                                type: 'error'
                              });
							  return;
			     }
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							
                  
                          if (this.editForm.open_type!='01')
						  {
                                this.editForm.url='';
						  }   
                         			         

							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;
							para["jump_params_tmp"]=JSON.stringify(this.editForm.jump_params_tmp);
							para["app_group_tmp"]=JSON.stringify(this.editForm.app_group_tmp);
							para["app_id_tmp"]=JSON.stringify(this.editForm.app_id_tmp);
							para["video"]=JSON.stringify(this.editForm.video);
							para["audio"]=JSON.stringify(this.editForm.audio);
							para["lyric_tmp"]=JSON.stringify(this.editForm.lyric_tmp);


                            var tmp_img=this.editForm.img_url_tmp.concat();
							for (var i=0;i<this.del_tmp.length;i++)
							{
							   for(var j=0; i<tmp_img.length; j++) {
								   if(tmp_img[j].name == this.del_tmp[i].name) {				  
												
											tmp_img.splice(j, 1);			  
											
										break;
								   }
								}
							}

							para["img_url_tmp"]=JSON.stringify(tmp_img.concat(this.edit_img_url));

               
						if (this.del_tmp.length>0){
							
				            this.imgDel(JSON.stringify(this.del_tmp),true);							
							this.del_tmp=[];
						}	


			   let infoUrl=	addInfo;			  
               if (this.formStatus==1)
			   {
                  infoUrl=editInfo;
			   }
                //this.$http.jsonp(infoUrl, {params: para}).then(
				this.$http.post(infoUrl, para,{emulateJSON:false}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {		
							// this.$refs['editForm'].resetFields();	
							this.editForm = {
								id: 0,									
								info_type:'01',
								title:'',
								content:'',
								open_type:'01',
								url:'',
								jump:'',
								jump_params_tmp:[],
								app_group_tmp:[],
								app_id_tmp:[],
								show_type:'1',
								top:false,
								img_url_tmp:[],
								article_id:'',
								app:'',
								play_name:'',
								author:'',
								duration:'',
								video:[],
								audio:[],
								lyric_tmp:[]
							};		
							    this.edit_img_url=[];		    
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getInfos();
                            
                         }
                         else{                           
                               this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
							  this.editLoading = false;	
                      
                   }
           )


						});
					}
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getInfos();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };
            

                   this.$http.jsonp(batchRemoveInfo, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
		
			this.getJump();
			this.getAppGroup();
			this.getBase();
			this.getInfos();
		
           
 	        
			
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// pusharticle.vue?119ca0d7